<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form :inline="true" class="form-inlines">
                <el-form-item>
                    <el-date-picker v-model="values" type="daterange" size="small" :clearable="false"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search_day">日对比</el-button>
                    <el-button type="primary" size="small" @click="submitTime(1)">昨</el-button>
                    <el-button type="primary" size="small" @click="submitTime(3)">3</el-button>
                    <el-button type="primary" size="small" @click="submitTime(7)">7</el-button>
                    <el-button type="primary" size="small" @click="submitTimeBy">本月</el-button>
                    <el-button type="primary" size="small" @click="submitTimeSy">上月</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="zdb_value1" size="small" type="week" format="yyyy 第 WW 周" ref="week1" placeholder="开始周"
                        value-format="yyyy-MM-dd" :clearable="false" id="week1" class="zwidth">
                    </el-date-picker>
                    <el-date-picker v-model="zdb_value2" size="small" type="week" format="yyyy 第 WW 周" ref="week2" placeholder="结束周"
                        value-format="yyyy-MM-dd" :clearable="false" id="week2" class="zwidth">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_week">周对比</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="ydb_value1" size="small" type="month" placeholder="开始月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
                    <el-date-picker v-model="ydb_value2" size="small" type="month" placeholder="结束月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_month">月对比</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" v-loading="loading" border :height="Heighttab" ref="table">
                <el-table-column v-for="(item,ind) in header" :key="ind" :label="item.name" align="center">
                    <el-table-column v-show="item.child.length>0" v-for="iteme in item.child" :prop="iteme.key" :key="iteme.key" :label="iteme.name" align="center">
                        <el-table-column v-show="iteme.child.length>0" v-for="itemed in iteme.child" :prop="itemed.key" :key="itemed.key" :label="itemed.name" align="center">
                        </el-table-column>
                        <template slot-scope="{row}" v-if="iteme.child.length<1">
                            {{row[iteme.key]}}
                        </template>
                    </el-table-column>
                    <template slot-scope="{row}" v-if="item.child.length<1">
                        {{row[item.key]}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                values: [],
                zdb_value1: '',
                zdb_value2: '',
                ydb_value1: '',
                ydb_value2: '',
                loading: false,
                header: [],
                tableData: [],
                Heighttab: null,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this;
            that.gettime();
            that.getheight();
        },
        methods: {
            gettime() {
                this.submitTime(7);
            },
            getheight() {
                let that = this;
                that.$nextTick(() => {
                    var titles = that.$refs.titles.offsetHeight
                    that.Heighttab = window.innerHeight - titles - 150 + 'px'
                    window.onresize = () => {
                        var titles = that.$refs.titles.offsetHeight
                        that.Heighttab = window.innerHeight - titles - 150 + 'px'
                    };
                })
            },

            search_day() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                axios.post("/admin/pc/report/OnlineConsulting", {
                        start_time: that.values[0],
                        end_time: that.values[1],
                        time_type: '1',
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.header = response.data.data.header
                        that.tableData = response.data.data.list
                        that.$nextTick(() => {
                            that.$refs.table.doLayout();
                        });
                    })
                    .catch(error => {})
            },
            search_week() {
                let that = this;
                var week1 = this.$refs.week1.displayValue
                var week2 =this.$refs.week2.displayValue
                that.header = [];
                that.tableData = [];
                if (week1 && week2) {
                    that.loading = true
                    var w1 = (week1.split('第 '))[1];
                    w1 = w1.split(' 周')[0];
                    var w2 = (week2.split('第 '))[1];
                    w2 = w2.split(' 周')[0];
                    axios.post("/admin/pc/report/OnlineConsulting", {
                            start_time: that.zdb_value1,
                            end_time: that.zdb_value2,
                            time_type: '3',
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false
                            that.header = response.data.data.header
                            that.tableData = response.data.data.list
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    this.$message({
                        showClose: true,
                        message: '请先选择第几周',
                        type: 'warning'
                    });
                }
            },
            search_month() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                if (this.ydb_value1 && this.ydb_value2) {
                    axios.post("/admin/pc/report/OnlineConsulting", {
                            start_time: that.ydb_value1,
                            end_time: that.ydb_value2,
                          
                            time_type: '2',
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false
                            that.header = response.data.data.header
                            that.tableData = response.data.data.list
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    that.loading = false
                    this.$message({
                        showClose: true,
                        message: '请先选择月份',
                        type: 'warning'
                    });
                }
            },
            //获取n天前时间
            submitTime(n) {
                //开始时间
                var nowDate = new Date();
                let befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                //截止时间
                let endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
                let year = endDate.getFullYear();
                let month = endDate.getMonth() + 1;
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = endDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                //赋值
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + bday,
                    year + "-" + month + "-" + day
                ];
                that.search_day();
            },
            //本月
            submitTimeBy() {
                let that = this
                var date = new Date();
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) month = "0" + month;
                let yuechu = date.getFullYear() + "-" + month + "-" + '01';
                if (day == 1) {
                    that.values = [yuechu, yuechu]
                } else {
                    day = day - 1;
                    if (day < 10) day = "0" + day;
                    let yuedi = date.getFullYear() + "-" + month + "-" + day;
                    that.values = [yuechu, yuedi]
                }
                that.search_day();
            },
            //上月
            submitTimeSy() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth();
                nowDate.setDate(0);
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = nowDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                let endTime = `${year}-${month}-${day}`;
                this.nowTime = endTime; // 当前的时间点
                let befDate = new Date(nowDate.getTime());
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                let startTime = `${byear}-${bmonth}-${bday}`;
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + "01",
                    byear + "-" + bmonth + "-" + day
                ];
                that.search_day();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .widthfixs {
        width: 160px !important;
    }

    .red {
        color: red;
    }
</style>